export const ADMIN_ROLE = "admin";
export const DOCTOR_ROLE = "doctor";
export const PRACTICE_ROLE = "practice";
export const PATIENT_ROLE = "patient";